// // import React, { useEffect, useState } from 'react';
// // import Logo from '../../../../assets/images/neophyte_logo.png';
// // import '../videoPage/video.css';
// // import { useSelector } from 'react-redux';

// // const EvidenceVideo = ({ vdoSource, videoList, setSource }) => {
// //   const [currentIndex, setCurrentIndex] = useState(videoList.findIndex((video) => `${video.src}` === vdoSource));
// //   const selectedSource = useSelector((state) => state.customization.videoSource);

// //   const extractGoogleDriveId = (url) => {
// //     if (!url) return null;

// //     try {
// //       const googleDrivePatterns = [/\/file\/d\/([a-zA-Z0-9_-]+)\//, /\/d\/([a-zA-Z0-9_-]+)\//, /id=([a-zA-Z0-9_-]+)/, /^([a-zA-Z0-9_-]+)$/];

// //       for (const pattern of googleDrivePatterns) {
// //         const match = url.match(pattern);
// //         if (match) return match[1];
// //       }
// //     } catch (error) {
// //       console.error('Error extracting Google Drive ID:', error);
// //     }

// //     return null;
// //   };

// //   const getGoogleDriveEmbedUrl = (url) => {
// //     const fileId = extractGoogleDriveId(url);
// //     if (!fileId) return null;

// //     return `https://drive.google.com/file/d/${fileId}/preview`;
// //   };

// //   const embedUrl = getGoogleDriveEmbedUrl(selectedSource);

// //   useEffect(() => {
// //     const newIndex = videoList.findIndex((video) => `${video.src}` === vdoSource);
// //     setCurrentIndex(newIndex !== -1 ? newIndex : 0);
// //   }, [vdoSource, videoList]);

// //   const handleVideoEnd = () => {
// //     const nextIndex = (currentIndex + 1) % videoList.length;
// //     setCurrentIndex(nextIndex);
// //     setSource(`${videoList[nextIndex].src}`);
// //   };

// //   return (
// //     <div className="video-component">
// //       {selectedSource ? (
// //         embedUrl ? (
// //           <iframe
// //             src={embedUrl}
// //             width="100%"
// //             height="60vh"
// //             style={{
// //               borderRadius: '10px',
// //               maxHeight: '60vh',
// //               minHeight: '60vh',
// //               maxWidth: '100%',
// //               minWidth: '100%',
// //               border: 'none'
// //             }}
// //             allow="autoplay"
// //           ></iframe>
// //         ) : (
// //           <video
// //             width="100%"
// //             height="60vh"
// //             style={{ borderRadius: '10px', maxHeight: '60vh', minHeight: '60vh', maxWidth: '100%', minWidth: '100%' }}
// //             controls
// //             autoPlay
// //             muted
// //             onEnded={handleVideoEnd}
// //           >
// //             <source src={selectedSource} type="video/mp4" />
// //             Your browser does not support the video tag.
// //           </video>
// //         )
// //       ) : (
// //         <div className="flex flex-col justify-center" style={{ height: '60vh' }}>
// //           <img src={Logo} alt="Logo" />
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default EvidenceVideo;

// import React, { useEffect, useState } from 'react';
// import Logo from '../../../../assets/images/neophyte_logo.png';
// import '../videoPage/video.css';
// import { useSelector } from 'react-redux';

// const EvidenceVideo = ({ vdoSource, videoList, setSource }) => {
//   const [currentIndex, setCurrentIndex] = useState(videoList.findIndex((video) => `${video.videos}` === vdoSource));
//   const selectedSource = useSelector((state) => state.customization.videoSource);
//   const [showVideo, setShowVideo] = useState(selectedSource);

//   useEffect(() => {
//     const newIndex = videoList.findIndex((video) => `${video.videos}` === vdoSource);
//     setCurrentIndex(newIndex !== -1 ? newIndex : 0);
//   }, [vdoSource, videoList]);

//   const handleVideoEnd = () => {
//     if (videoList.length === 0) return;

//     const nextIndex = (currentIndex + 1) % videoList.length;
//     setCurrentIndex(nextIndex);
//     setSource(`https://db.neophyte.live/fm/videos/${videoList[nextIndex].src}`);
//   };

//   console.log('dcdcd', selectedSource);

//   useEffect(() => {
//     setShowVideo(selectedSource);
//   }, [selectedSource]);

//   return (
//     <div className="video-component">
//       {showVideo ? (
//         <video
//           width="100%"
//           height="60vh"
//           style={{
//             borderRadius: '10px',
//             maxHeight: '60vh',
//             minHeight: '60vh',
//             maxWidth: '100%',
//             minWidth: '100%',
//             backgroundColor: '#000' // Added for better visibility
//           }}
//           controls
//           autoPlay
//           muted
//           onEnded={handleVideoEnd}
//           key={selectedSource} // Important for forcing re-render when source changes
//         >
//           <source src={selectedSource} type="video/mp4" />
//           Your browser does not support the video tag.
//         </video>
//       ) : (
//         <div className="flex flex-col justify-center items-center" style={{ height: '60vh' }}>
//           <img src={Logo} alt="Logo" style={{ maxHeight: '150px', opacity: 0.5 }} />
//           <p className="text-gray-500 mt-4">No video selected</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EvidenceVideo;

// // import React, { useEffect, useState } from 'react';
// // import Logo from '../../../../assets/images/neophyte_logo.png';
// // import '../videoPage/video.css';
// // import { useSelector } from 'react-redux';

// // const EvidenceVideo = ({ vdoSource, videoList, setSource }) => {
// //   const [currentIndex, setCurrentIndex] = useState(videoList.findIndex((video) => `${video.src}` === vdoSource));
// //   const selectedSource = useSelector((state) => state.customization.videoSource);
// //   const [showVideo, setShowVideo] = useState(selectedSource);

// //   useEffect(() => {
// //     const newIndex = videoList.findIndex((video) => `https://db.neophyte.live/fm/videos/${video.src}` === vdoSource);
// //     setCurrentIndex(newIndex !== -1 ? newIndex : 0);
// //   }, [vdoSource, videoList]);

// //   useEffect(() => {
// //     setShowVideo(selectedSource);
// //   }, [selectedSource]);

// //   const handleVideoEnd = () => {
// //     const nextIndex = (currentIndex + 1) % videoList.length;
// //     setCurrentIndex(nextIndex);
// //     setSource(`https://db.neophyte.live/fm/videos/${videoList[nextIndex].src}`);
// //   };
// //   console.log('sdsd', selectedSource);

// //   return (
// //     <div className="video-component">
// //       {showVideo ? (
// //         <video
// //           width="100%"
// //           height="60vh"
// //           style={{ borderRadius: '10px', maxHeight: '60vh', minHeight: '60vh', maxWidth: '100%', minWidth: '100%' }}
// //           controls
// //           autoPlay
// //           muted
// //           onEnded={handleVideoEnd}
// //         >
// //           <source src={showVideo} type="video/mp4" />
// //           Your browser does not support the video tag.
// //         </video>
// //       ) : (
// //         <div className="flex flex-col justify-center" style={{ height: '60vh' }}>
// //           <img src={Logo} alt="Logo" />
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default EvidenceVideo;





import React, { useEffect, useState } from 'react';
import Logo from '../../../../assets/images/neophyte_logo.png';
import '../videoPage/video.css';
import { useSelector } from 'react-redux';

const EvidenceVideo = ({ vdoSource, videoList, setSource }) => {
  const [currentIndex, setCurrentIndex] = useState(videoList.findIndex((video) => `${video.src}` === vdoSource));
  const selectedSource = useSelector((state) => state.customization.videoSource);
  const [showContent, setShowContent] = useState(selectedSource);
  const [contentType, setContentType] = useState('video'); // 'video' or 'image'

  // Function to detect if URL is an image or video
  const detectContentType = (url) => {
    if (!url) return 'video';
    
    // Check file extension
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
    const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv'];
    
    const urlLower = url.toLowerCase();
    
    // Check for image extensions
    if (imageExtensions.some(ext => urlLower.includes(ext))) {
      return 'image';
    }
    
    // Check for video extensions
    if (videoExtensions.some(ext => urlLower.includes(ext))) {
      return 'video';
    }
    
    // Check for Azure blob storage patterns
    if (url.includes('blob.core.windows.net') && url.includes('.jpg')) {
      return 'image';
    }
    
    // Default to video for unknown types
    return 'video';
  };

  useEffect(() => {
    const newIndex = videoList.findIndex((video) => `${video.src}` === vdoSource);
    setCurrentIndex(newIndex !== -1 ? newIndex : 0);
  }, [vdoSource, videoList]);

  useEffect(() => {
    setShowContent(selectedSource);
    setContentType(detectContentType(selectedSource));
  }, [selectedSource]);

  const handleVideoEnd = () => {
    const nextIndex = (currentIndex + 1) % videoList.length;
    setCurrentIndex(nextIndex);
    setSource(`${videoList[nextIndex].src}`);
  };

  console.log('Selected source:', selectedSource);
  console.log('Content type:', contentType);

  return (
    <div className="video-component">
      {showContent ? (
        contentType === 'image' ? (
          <div 
            className="image-container"
            style={{ 
              width: '100%', 
              height: '60vh', 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              backgroundColor: '#000',
              borderRadius: '10px',
              overflow: 'hidden'
            }}
          >
            <img
              src={showContent}
              alt="Evidence"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                borderRadius: '10px'
              }}
              onError={(e) => {
                console.error('Error loading image:', e);
                // Fallback to video if image fails to load
                setContentType('video');
              }}
            />
          </div>
        ) : (
          <video
            width="100%"
            height="60vh"
            style={{ 
              borderRadius: '10px', 
              maxHeight: '60vh', 
              minHeight: '60vh', 
              maxWidth: '100%', 
              minWidth: '100%',
              backgroundColor: '#000'
            }}
            controls
            autoPlay
            muted
            onEnded={handleVideoEnd}
            onError={(e) => {
              console.error('Error loading video:', e);
              // Try as image if video fails
              setContentType('image');
            }}
          >
            <source src={showContent} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )
      ) : (
        <div className="flex flex-col justify-center items-center" style={{ height: '60vh' }}>
          <img src={Logo} alt="Logo" style={{ maxHeight: '150px', opacity: 0.5 }} />
          <p className="text-gray-500 mt-4">No content selected</p>
        </div>
      )}
    </div>
  );
};

export default EvidenceVideo;
